import { Component } from '@angular/core';

/**
 * Mention legale reCAPTCHA v3.
 *
 * La v3 n'affiche aucun widget : le client ne fait rien, le jeton est demande
 * en arriere-plan a la soumission. Google impose alors soit de laisser son
 * badge flottant visible, soit d'afficher ce texte.
 *
 * On a choisi le texte : le badge est en position fixe en bas a droite, la ou
 * vit deja la bulle de chat Chatwoot du site. Il est masque dans styles.css.
 */
@Component({
  selector: 'app-recaptcha',
  template: `
    <p class="recaptcha-notice">
      This site is protected by reCAPTCHA and the Google
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener"
        >Privacy Policy</a
      >
      and
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener"
        >Terms of Service</a
      >
      apply.
    </p>
  `,
  styles: [
    `
      .recaptcha-notice {
        margin: 10px 0 0;
        font-size: 11px;
        line-height: 1.4;
        /* Herite de la couleur du formulaire : les panneaux sombres du site
           (September Peak Sale, Black Friday) comme les fonds clairs restent
           lisibles sans thème a choisir, contrairement au widget v2. */
        color: inherit;
        opacity: 0.75;
      }
      .recaptcha-notice a {
        color: inherit;
        text-decoration: underline;
      }
    `,
  ],
})
export class RecaptchaComponent {}
